// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__300pO","errors":"Errors_errors__3ia1M"};